import {Anchor as MantineAnchor} from '@mantine/core';

/**
 * Styled link — design-layer pass-through over Mantine `Anchor`.
 * @registry Pass-through Mantine Anchor; import this instead of @mantine/core outside src/design.
 */
export const Anchor = MantineAnchor;
